import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { interval } from 'rxjs';
import { map, tap } from 'rxjs/operators';


import { REAL_TIME_REQUEST, REAL_TIME_SUBSCRIPTION } from '../models/graphQL/subscriptions/real-time-graphlQl.subscription';

@Injectable({
  providedIn: 'root'
})
export class RealTimeService {

  constructor(private apollo: Apollo) { }

  _x: number[] = [];
  _y: number[] = [];
  _iter = 0;
  data$: Observable<{ topic: string, data: { x: number[], y: number[] } } | null> = of(null);
  data2$: Observable<any> = of(null);


  subscriptionRequest(topic: string, payload: string) {
    return this.apollo.mutate<any>({
      mutation: REAL_TIME_REQUEST,
      variables: {
        topic: topic,
        payload: payload
      },
      fetchPolicy: 'no-cache'
    })

  }

  subscribeToMqttRT() {
    return this.apollo.subscribe<any>({
      query: REAL_TIME_SUBSCRIPTION
    })
  }


  connect(type: string, mode: string, topic, payload: any, color: string = 'rgb(55, 128, 191)') {
    this.data$ = new BehaviorSubject(null)
      .pipe(
        map(() => {
          this._x.push(payload.fecha);
          this._y.push(
            parseFloat(payload.valor)
          );
          if (this._y.length > 25) {

            this._x = this._x.slice(1, -1);
            this._y = this._y.slice(1, -1);
          }

          return {
            topic: topic,
            data: {
              x: this._x,
              y: this._y,
              line: {
                color: color,
                width: 1
              },
              mode: mode,
              type: type,

            }
          }
        })
      );



    return this.data$;
  }



}
